import { createSelector } from 'reselect';

export const selectedJudgement = (state: any) => {
  return state.get('lawyerJudgement');
};

const makeSelectJudgementAdd = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('judgementAdd')) {
      return judgement.get('judgementAdd').toJS();
    }
    return {};
  });

const makeSelectJudgementAddAppeal = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('judgementAddAppeal')) {
      return judgement.get('judgementAddAppeal').toJS();
    }
    return {};
  });

const makeSelectDahirAmountsCorpo = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('dahirAmountsCorpo')) {
      return judgement.get('dahirAmountsCorpo').toJS();
    }
    return {};
  });
const makeSelectExpertiseRaport = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('expertiseRaport')) {
      return judgement.get('expertiseRaport').toJS();
    }
    return {};
  });

const makeSelectExpertiseRaportAppeal = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('expertiseRaportAppeal')) {
      return judgement.get('expertiseRaportAppeal').toJS();
    }
    return {};
  });

const makeSelectJudgementOnMerits = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('judgementOnMerits')) {
      return judgement.get('judgementOnMerits').toJS();
    }
    return {};
  });

const makeSelectJudgementOnMeritsMultiple = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('judgementOnMeritsMultiple')) {
      return judgement.get('judgementOnMeritsMultiple').toJS();
    }
    return [];
  });
const makeSelectAppealOnMeritsMultiple = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('appealOnMeritsMultiple')) {
      return judgement.get('appealOnMeritsMultiple').toJS();
    }
    return [];
  });
const makeSelectJudgementOnMeritsAppeal = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('judgementOnMeritsAppeal')) {
      return judgement.get('judgementOnMeritsAppeal').toJS();
    }
    return {};
  });
const makeSelectJudgementAppeal = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('judgementAppeal')) {
      return judgement.get('judgementAppeal').toJS();
    }
    return {};
  });
const makeSelectCivilProceeding = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('civilProceeding')) {
      return judgement.get('civilProceeding').toJS();
    }
    return {};
  });
const makeSelectDahirAmounts = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('judgementAppeal')) {
      return judgement.get('dahirAmounts').toJS();
    }
    return [];
  });
const makeSelectLockedClaim = () =>
  createSelector(selectedJudgement, judgement => {
    if (judgement && judgement.get('lockedClaim')) {
      return judgement.get('lockedClaim');
    }
    return null;
  });

export {
  makeSelectJudgementAdd,
  makeSelectExpertiseRaport,
  makeSelectJudgementOnMerits,
  makeSelectJudgementAppeal,
  makeSelectDahirAmounts,
  makeSelectCivilProceeding,
  makeSelectDahirAmountsCorpo,
  makeSelectJudgementOnMeritsAppeal,
  makeSelectExpertiseRaportAppeal,
  makeSelectJudgementAddAppeal,
  makeSelectJudgementOnMeritsMultiple,
  makeSelectAppealOnMeritsMultiple,
  makeSelectLockedClaim,
};
